export class FilterState {
    constructor() {
        this.filters = {
            category: [],
            country: [],
            province: [],
        };
        this.hierarchy = {
            country: ['province'],
        };
    }
    get all() {
        return this.filters;
    }
    get hasActive() {
        return Object.values(this.filters).some(group => group.some(f => !f.fixed));
    }
    toggle(type, filter) {
        const group = this.filters[type];
        const index = group.findIndex(f => f.id === filter.id);
        if (index > -1) {
            if (this.isFixed(group[index]))
                return;
            group.splice(index, 1);
            this.removeChildren(type, filter.id);
        }
        else {
            group.push(filter);
        }
    }
    remove(type, id) {
        const filter = this.filters[type].find(f => f.id === id);
        if (this.isFixed(filter))
            return;
        this.filters[type] = this.filters[type].filter(f => f.id !== id);
        this.removeChildren(type, id);
    }
    reset() {
        Object.keys(this.filters).forEach(type => {
            this.filters[type] = this.filters[type].filter(f => this.isFixed(f));
        });
    }
    removeChildren(parentType, parentId) {
        const children = this.hierarchy[parentType];
        if (!children)
            return;
        children.forEach(childType => {
            const childFilters = this.filters[childType].filter(f => f.parentId === parentId && !this.isFixed(f));
            childFilters.forEach(f => {
                this.filters[childType] = this.filters[childType].filter(cf => cf.id !== f.id);
                this.removeChildren(childType, f.id);
            });
        });
    }
    isFixed(filter) {
        return (filter === null || filter === void 0 ? void 0 : filter.fixed) === true;
    }
}
